
export class Configuration {

    photo_logo_position: string;
    photo_logo_margin: string;
    photo_logo_opacity: string;
    multi_agence: boolean;
    synchro_agenda_suppression: boolean;
    option_social_fr: boolean;
    echange_donnees: boolean;
    Z16Gestion: boolean;
    affichage_z16Gestion_only: boolean;
    honoraire_agence_db: boolean;
    afficher_pourcentage_commerciaux_lot: boolean;
    stacking_plan: boolean;
    type_mandat_db: boolean;
    transfert_bien_interbureau: boolean;
    interagence_publish_to: string;
    show_lots_interagence_in: string;
    libelle_menu_bourse: string;
    echange_donnees_adminagim: string;
    is_telescop_activated: boolean;
    z16Pro: boolean;
    module_calcul_prix_a17: boolean;
    a17_selecteurs: string;
    giorgetti_optimax: string;
    usePrefixe: boolean;
    prefixe: string;
    country: string;
    header_footer_color: string;
    submenus_color: string;
    nav_text_color: string;
    methode_numerotation_facture: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.photo_logo_position                    = data['photo_logo_position'] ? data['photo_logo_position'] : null;
        this.photo_logo_margin                      = data['photo_logo_margin'] ? data['photo_logo_margin'] : null;
        this.photo_logo_opacity                     = data['photo_logo_opacity'] ? data['photo_logo_opacity'] : null;
        this.multi_agence                           = data['multi_agence'] && data['multi_agence'] === '1' ? true : false;
        this.option_social_fr                       = data['option_social_fr'] && data['option_social_fr'] === '1' ? true : false;
        this.echange_donnees                        = data['echange_donnees'];
        this.Z16Gestion                             = data['z16Gestion'];
        this.affichage_z16Gestion_only              = data['affichage_z16Gestion_only'];
        this.honoraire_agence_db                    = data['honoraire_agence_db'] && data['honoraire_agence_db'] === '1' ? true : false;
        this.afficher_pourcentage_commerciaux_lot   = data['afficher_pourcentage_commerciaux_lot'] && data['afficher_pourcentage_commerciaux_lot'] === '1' ? true : false;
        this.type_mandat_db                         = data['type_mandat_db'] && data['type_mandat_db'] === '1' ? true : false;
        this.z16Pro                                 = data['z16Pro'] && data['z16Pro'] === '1' ? true : false;
        this.stacking_plan                          = data['stacking_plan'] && data['stacking_plan'] === '1' ? true : false;
        this.transfert_bien_interbureau             = data['transfert_bien_interbureau'] && data['transfert_bien_interbureau'] === '1' ? true : false;
        this.interagence_publish_to                 = data['interagence_publish_to'] ? data['interagence_publish_to'] : Configuration.INTERAGENCE_TO_BOURSE;
        this.show_lots_interagence_in               = data['show_lots_interagence_in'] ? data['show_lots_interagence_in'] : Configuration.SHOW_INTERAGENCE_DEDICATED;
        this.libelle_menu_bourse                    = data['libelle_menu_bourse'];
        this.echange_donnees_adminagim              = data['echange_donnees_adminagim'];
        this.is_telescop_activated                  = data['is_telescop_activated'];
        this.module_calcul_prix_a17                 = data['module_calcul_prix_a17'] && data['module_calcul_prix_a17'] === '1';
        this.a17_selecteurs                         = data['a17_selecteurs'];
        this.giorgetti_optimax                      = data['giorgetti_optimax']  ?  data['giorgetti_optimax'] : null;
        this.usePrefixe                             = data['usePrefixe'] && data['usePrefixe'] === '1' ;
        this.prefixe                                = data['prefixe'] ? data['prefixe'] : null;
        this.country                                = data['country'] ? data['country'] : null;
        this.methode_numerotation_facture           = data['methode_numerotation_facture'] ? data['methode_numerotation_facture'] : null;
    }

    toBackEntity() {
        return {
            'photo_logo_position'                   : this.photo_logo_position,
            'photo_logo_margin'                     : this.photo_logo_margin,
            'photo_logo_opacity'                    : this.photo_logo_opacity,
            'multi_agence'                          : this.multi_agence,
            'synchro_agenda_suppression'            : this.synchro_agenda_suppression,
            'option_social_fr'                      : this.option_social_fr,
            'z16Pro'                                : this.z16Pro,
            'afficher_pourcentage_commerciaux_lot'  : this.afficher_pourcentage_commerciaux_lot,
            'echange_donnees'                       : this.echange_donnees,
            'stacking_plan'                         : this.stacking_plan,
            'honoraire_agence_db'                   : this.honoraire_agence_db,
            'type_mandat_db'                        : this.type_mandat_db,
            'transfert_bien_interbureau'            : this.transfert_bien_interbureau,
            'z16Gestion'                            : this.Z16Gestion,
            'affichage_z16Gestion_only'             : this.affichage_z16Gestion_only,
            'interagence_publish_to'                : this.interagence_publish_to,
            'show_lots_interagence_in'              : this.show_lots_interagence_in,
            'libelle_menu_bourse'                   : this.libelle_menu_bourse,
            'module_calcul_prix_a17'                : this.module_calcul_prix_a17,
            'a17_selecteurs'                        : this.a17_selecteurs,
            'header_footer_color'                   : this.header_footer_color,
            'submenus_color'                        : this.submenus_color,
            'nav_text_color'                        : this.nav_text_color,
            'methode_numerotation_facture'          : this.methode_numerotation_facture
        };
    }

    // CONSTANT GETTERS
    static get INTERAGENCE_TO_BOURSE() { return 'bourse'; }
    static get INTERAGENCE_TO_AGENCE() { return 'interagence'; }

    static get SHOW_INTERAGENCE_LOTS() { return 'lots'; }
    static get SHOW_INTERAGENCE_DEDICATED() { return 'menu_dedie'; }
}
